// 알림 API
import axiosInstance from './axiosInstance';

// ── 텔레그램 설정 ──────────────────────────────────────────
export const fetchTelegramSettings = async () => {
  const res = await axiosInstance.get('/telegram/settings');
  return res.data.data;
};

export const saveTelegramSettings = async (payload) => {
  const res = await axiosInstance.put('/telegram/settings', payload);
  return res.data;
};

export const fetchChatIdUrl = async () => {
  const res = await axiosInstance.get('/telegram/chat-id-url');
  return res.data.url;
};

export const sendTelegramTest = async (chatId) => {
  const res = await axiosInstance.post('/telegram/test', { chat_id: chatId });
  return res.data;
};

// ── 알림 유형 CRUD (tb_alert_type) ─────────────────────────
export const fetchAlertTypes = async () => {
  const res = await axiosInstance.get('/alert-type');
  return res.data;
};

export const createAlertType = async (payload) => {
  const res = await axiosInstance.post('/alert-type', payload);
  return res.data;
};

export const updateAlertType = async (id, payload) => {
  const res = await axiosInstance.put(`/alert-type/${id}`, payload);
  return res.data;
};

export const deleteAlertType = async (id) => {
  const res = await axiosInstance.delete(`/alert-type/${id}`);
  return res.data;
};

// ── 매수 알림 설정 (tb_buy_alert) ──────────────────────────
export const fetchBuyAlert = async (buyId) => {
  const res = await axiosInstance.get(`/buy/${buyId}/alert`);
  return res.data;
};

export const saveBuyAlert = async (buyId, payload) => {
  const res = await axiosInstance.put(`/buy/${buyId}/alert`, payload);
  return res.data;
};

// ── 매도 알림 설정 (tb_sell_alert) ─────────────────────────
export const fetchSellAlert = async (sellId) => {
  const res = await axiosInstance.get(`/sell/${sellId}/alert`);
  return res.data;
};

export const saveSellAlert = async (sellId, payload) => {
  const res = await axiosInstance.put(`/sell/${sellId}/alert`, payload);
  return res.data;
};

// ── 시장지수/환율 알림 CRUD (tb_alert_config) ──────────────
export const fetchAlertConfigs = async () => {
  const res = await axiosInstance.get('/alert-config');
  return res.data;
};

export const createAlertConfig = async (payload) => {
  const res = await axiosInstance.post('/alert-config', payload);
  return res.data;
};

export const updateAlertConfig = async (id, payload) => {
  const res = await axiosInstance.put(`/alert-config/${id}`, payload);
  return res.data;
};

export const deleteAlertConfig = async (id) => {
  const res = await axiosInstance.delete(`/alert-config/${id}`);
  return res.data;
};

export const toggleAlertConfig = async (id) => {
  const res = await axiosInstance.put(`/alert-config/${id}/toggle`);
  return res.data;
};

// ── 발송 이력 ──────────────────────────────────────────────
export const fetchAlertHistory = async (page = 1, limit = 20) => {
  const res = await axiosInstance.get('/alert-history', { params: { page, limit } });
  return res.data;
};

// ── 수동 알림체크 ──────────────────────────────────────────
export const runAlertCheckNow = async () => {
  const res = await axiosInstance.post('/alert/check-now');
  return res.data;
};
